// extracted by mini-css-extract-plugin
export default {"Title":"Mailer_Title__SNY3D"};